import { compose } from "redux";
import { connect } from "react-redux";
import { get } from 'lodash';

import QRCode from './QRCode';

const mapStateToProps = state => ({

});

export default compose(
  connect(mapStateToProps),
)(QRCode);